module.exports = __webpack_public_path__ + "static/GFX-ebook-default-85015048fffafc11b393024ec4cfc8d3.png";